import * as _ from "lodash";
import DataGenerator from "../DataGenerator";
import {INodeModel} from "@/shared/models/abstract/INodeModel";
import {EntityType} from "@/shared/models/entityType";
import NodeBaseModel from "@/shared/models/abstract/nodeBaseModel";

export default class PersonModel extends NodeBaseModel {
    constructor(firstName: string = null, lastName: string = null) {
        super(EntityType.Person, "PERSON");
        this._firstName = firstName;
        this._lastName = lastName;
        this.updateName();
    }

    private _nickName: string;

    get nickName(): string {
        return this._nickName;
    }

    set nickName(value: string) {
        this._nickName = value;
        this.raisePropertyChanged("nickName");
        this.updateName();
    }

    private _firstName: string;

    get firstName(): string {
        return this._firstName;
    }

    set firstName(value: string) {
        this._firstName = value;
        this.raisePropertyChanged("firstName");
        this.updateName();
    }

    private _lastName: string;

    get lastName(): string {
        return this._lastName;
    }

    set lastName(value: string) {
        this._lastName = value;
        this.raisePropertyChanged("lastName");
        this.updateName();
    }

    static fromJson(json) {
        if (json.entityType !== EntityType.Person) {
            throw new Error("Wrong deserialization data.");
        }
        let m = new PersonModel();
        m = _.assign(m, json);
        return m;
    }

    updateName() {
        const firstName = (this.firstName || "").trim();
        const lastName = (this.lastName || "").trim();
        const nickName = (this.nickName || "").trim();

        let s = firstName;
        if (lastName.length > 0) {
            s += ` ${lastName}`;
        }
        if (nickName.length > 0) {
            s += ` [${nickName}]`;
        }
        this.name = s;
    }

    toJson() {
        const m = super.toJson();
        m.firstName = this._firstName;
        m.lastName = this._lastName;
        m.nickName = this._nickName;
        return m;
    }

    clone() {
        const clone = PersonModel.fromJson(this.toJson());
        clone.id = DataGenerator.id();
        return clone;
    }
};
